/**
 * Centres one or more `FeaturedAlert`s over the page content instead of
 * pushing it down.
 *
 * The Figma draws success and error messages as cards floating at the top
 * of the content area, 498px wide with a hugging height — the same
 * treatment the Auto-fill toast in `pages/submission/layout.tsx` already
 * uses inline. Warning banners are the exception: those sit in the flow,
 * because they describe a condition of the page rather than the outcome of
 * an action.
 *
 * Positions against the nearest positioned ancestor, so the host scroll
 * container needs `relative`. Pointer events are off on the backdrop and
 * back on for the card, so the invisible full-width strip can't swallow
 * clicks meant for whatever is underneath.
 */
import type { ReactNode } from "react";

export function FloatingAlert({ children }: { children: ReactNode }) {
    return (
        <div className="pointer-events-none absolute inset-x-0 top-0 z-30 flex justify-center px-4">
            {/* 498px is the Figma's fixed width; the height hugs its content. */}
            <div className="pointer-events-auto flex w-[498px] max-w-full flex-col gap-3">{children}</div>
        </div>
    );
}
